import { render, staticRenderFns } from "./ProfileMain.vue?vue&type=template&id=63a09ae6&scoped=true"
import script from "./ProfileMain.vue?vue&type=script&lang=js"
export * from "./ProfileMain.vue?vue&type=script&lang=js"
import style0 from "./ProfileMain.vue?vue&type=style&index=0&id=63a09ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a09ae6",
  null
  
)

export default component.exports